module.exports = __webpack_public_path__ + "static/img/main_txt_02.3c5fa0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main/main_txt_02.png
// module id = jDFb
// module chunks = 1